import { format, subDays } from 'date-fns'

const sixtyDaysAgo = format(subDays(new Date(), 59), "yyyy-MM-dd'T00:00:00'xxx")
const endOfToday = format(new Date(), "yyyy-MM-dd'T23:59:59'xxx")

// Action Types
export const SET_FILES = 'audioIngestion/setFiles'
export const SET_FILE_UPLOADING = 'audioIngestion/setFileUploading'
export const SET_FILE_DONE = 'audioIngestion/setFileDone'
export const SET_FILE_ERROR = 'audioIngestion/setFileError'
export const SET_FILE_LANGUAGE_RETRIED = 'audioIngestion/setFileLanguageRetried'
export const CLEAR_FILES = 'audioIngestion/reset'
export const SET_AUDIO_INGESTION_RECORDS = 'audioIngestion/setAudioIngestionRecords'
export const SET_LOADING = 'audioIngestion/setLoading'

// Action Creators
export const setFiles = (payload) => ({ type: SET_FILES, payload })
export const setFileUploading = (payload) => ({ type: SET_FILE_UPLOADING, payload })
export const setFileDone = (payload) => ({ type: SET_FILE_DONE, payload })
export const setFileError = (payload) => ({ type: SET_FILE_ERROR, payload })
export const setFileLanguageRetried = (payload) => ({ type: SET_FILE_LANGUAGE_RETRIED, payload })
export const clearFiles = () => ({ type: CLEAR_FILES })
export const setAudioIngestionRecords = (payload) => ({
  type: SET_AUDIO_INGESTION_RECORDS,
  payload,
})
export const setLoading = (payload) => ({ type: SET_LOADING, payload })

// State
// files is an array of file objects that contain the following properties:
// instance: the actual instance of the File
// isUploading: boolean value to determine is the file is in the process of being uploaded
// isDone: boolean value that flags the file as done (fully uploaded)
// isError: boolean value that flags the file had an error
// errorMsg: the message associated with the error
// callId: uuid of the call attached to the file, it is returned once the file is complete
export const initialState = {
  files: [],
  audioIngestion: {
    records: [],
    total: 0,
    lastJobRunTime: null,
    filters: {
      organizationId: null,
      startDate: sixtyDaysAgo,
      endDate: endOfToday,
      dateInvalid: false,
    },
  },
  loading: {
    records: false,
  },
}

export default function audioIngestionReducer(state = initialState, action) {
  const { payload, type } = action
  let updatedFiles
  let files

  switch (type) {
    case SET_FILES:
      files = payload.map((file) => {
        return {
          instance: file,
          isUploading: false,
          isDone: false,
          callId: null,
        }
      })
      return { ...state, files }
    case SET_FILE_UPLOADING:
      updatedFiles = state.files.map((file) => {
        if (file.instance.name === payload.name) {
          return { ...file, isUploading: true }
        }

        return file
      })

      return { ...state, files: updatedFiles }
    case SET_FILE_DONE:
      updatedFiles = state.files.map((file) => {
        if (file.instance.name === payload.file.name) {
          return { ...file, isDone: true, isUploading: false, callId: payload.callId }
        }

        return file
      })

      return { ...state, files: updatedFiles }
    case SET_FILE_ERROR:
      updatedFiles = state.files.map((file) => {
        if (file.instance.name === payload.file.name) {
          return {
            ...file,
            isDone: true,
            isUploading: false,
            callId: null,
            isError: true,
            errorMsg: payload.errorMsg,
          }
        }

        return file
      })

      return { ...state, files: updatedFiles }
    case SET_FILE_LANGUAGE_RETRIED:
      updatedFiles = state.files.map((file) => {
        if (file.instance.name === payload.name) {
          return { ...file, languageRetried: true }
        }

        return file
      })

      return { ...state, files: updatedFiles }
    case SET_AUDIO_INGESTION_RECORDS:
      return {
        ...state,
        audioIngestion: {
          ...state.audioIngestion,
          records: payload.records,
          total: payload.total,
          lastJobRunTime: payload.lastJobRunTime,
          filters: { ...state.audioIngestion.filters, ...payload.filters },
        },
      }
    case SET_LOADING:
      return { ...state, loading: { ...state.loading, ...payload } }
    case CLEAR_FILES:
      return initialState
    default:
      return state
  }
}
